import { ALGOS_E } from "@constants/Algos";
import { getDevivedHash } from "@utils/hash.utils";
import { utcTimeFormat } from "@utils/moscowTime";
import cn from "classnames";
import moment from "moment";
import { useIntl } from "react-intl";
import ChartColors from "./ChartColors";
import styles from "./Charts.module.scss";

interface LastChartInfoProps {
  isHide: boolean;
  //currentColor: ChartColors;
  defaultSpeed: number | undefined;
  speedDrops: number | undefined;
  timeAndHash: [number, number, number];
  coords: [number, number];
  hashAlgo?: ALGOS_E;
}

export default function LastChartInfo({
  isHide,
  //currentColor,
  defaultSpeed,
  speedDrops,
  timeAndHash,
  coords,
  hashAlgo = ALGOS_E.SHA256,
}: LastChartInfoProps) {
  const { formatMessage } = useIntl();

  const currentColor = (hash: number) => {
    if (defaultSpeed === undefined || speedDrops === undefined)
      return ChartColors.BG_PRIMARY;
    const defaultSpeedReal = defaultSpeed * 0.95;
    if (hash > defaultSpeedReal) return ChartColors.SECONDARY;
    if (hash < defaultSpeedReal && hash > speedDrops) return ChartColors.LOW;
    if (hash < speedDrops) return ChartColors.OFF;
  };

  const isNow = () => {
    return moment
      .tz(timeAndHash[0], "Europe/Moscow")
      .isSame(
        moment(
          new Date().getTime() +
          (window.SERVER_TIME_DELTA ? window.SERVER_TIME_DELTA : 0)
        ),
        "days"
      );
  };

  const renderSpeed = () => {
    return `${isNow()
      ? formatMessage({ id: "chart_hash.last_info.speed_now" })
      : formatMessage({ id: "chart_hash.last_info.speed" })
      } ${getDevivedHash(timeAndHash[1], { unit: hashAlgo })}`;
  };

  const renderRejectRate = () => {
    if (timeAndHash.length > 2 && timeAndHash[2] !== -1) {
      return `${formatMessage({ id: "chart.reject_rate" })}: ${timeAndHash[2].toFixed(2)}%`;
    }
    return "";
  }

  const hasValues = (): boolean => {
    return timeAndHash && timeAndHash.length > 1 && timeAndHash[1] > 0;
  };

  return (
    <>
      {hasValues() && (
        <div
          className={cn(styles.chart_info, {
            [styles.hide]: isHide,
          })}
          style={{
            background: `linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, ${currentColor(
              timeAndHash[1]
            )} 80.33%)`,
            // left: control.coords && control.coords[0] - 160,
            right: 0,
            top: coords && coords[1],
          }}
        >
          <label>
            {utcTimeFormat(timeAndHash[0], "DD/MM/YY HH:mm")}
          </label>
          <p>
            <span>{renderSpeed()}</span>
          </p>
          <p>
            <span>{renderRejectRate()}</span>
          </p>
        </div>
      )}
    </>
  );
}
